module.exports = __webpack_public_path__ + "static/img/7.5e46075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/7.png
// module id = fk2W
// module chunks = 1